import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonWorkResourceList } from "./Common/CommonWorkResourceList";

const WorkResourcePage = () => {
	return (
		<PageWrapper title='Ferramentas e EPI'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-12'>
						<CommonWorkResourceList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default WorkResourcePage;